import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import {
  APPLICANT_CV_ROUTE,
  JOB_APPLICANTS_ROUTE,
  LISTING_LEADS_ROUTE,
  LISTING_STATS_ROUTE,
  LISTING_VIEW_ROUTE,
  MY_LISTINGS_ROUTE,
  NOT_FOUND_ROUTE,
} from './constants';

const MainLayout = lazy(() => import('newApp/layouts/main-layout/MainLayout'));
const MyListingsPage = lazy(() => import('./pages/my-listings/MyListingsPage'));
const ListingDraft = lazy(() => import('./pages/listing-draft/ListingDraftPage'));
const loadListingViewPage = () => import('./pages/listing-view/ListingViewPage');
const ListingViewPage = lazy(loadListingViewPage);
const ListingStatsPage = lazy(() => import('./pages/listing-stats/ListingStatsPage'));
const ListingLeadsPage = lazy(() => import('./pages/listing-leads/ListingLeadsPage'));
const JobApplicantsPage = lazy(() => import('./pages/job-applicants/JobApplicantsPage'));
const ApplicantCVFullView = lazy(
  () => import('./pages/applicant-cv-full-view/ApplicantCVFullView'),
);
const RecentSearchPage = lazy(() => import('./pages/recent-search/RecentSearchPage'));
const SavedSearchPage = lazy(() => import('./pages/saved-search/SavedSearchPage'));
const FavoriteListingsPage = lazy(() => import('./pages/favorite-listings/FavoriteListingsPage'));
const JobApplicationsPage = lazy(() => import('./pages/job-applications/JobApplicationsPage'));
const RecentlyViewedPage = lazy(() => import('./pages/recently-viewed/RecentlyViewedPage'));
const FollowingListingsPage = lazy(
  () => import('./pages/following-listings/FollowingListingsPage'),
);

if (window.location.pathname.endsWith(LISTING_VIEW_ROUTE)) {
  void loadListingViewPage();
}

const listingRoutes = [
  {
    path: '/listings',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <Navigate replace to={NOT_FOUND_ROUTE} />,
      },
      {
        path: '*',
        element: <Navigate replace to={NOT_FOUND_ROUTE} />,
      },
      {
        path: MY_LISTINGS_ROUTE,
        element: <MyListingsPage />,
        handle: {
          title: 'routes.listings.myListings',
          breadcrumb: 'routes.listings.myListings',
        },
      },
      {
        path: LISTING_VIEW_ROUTE,
        element: <ListingViewPage />,
        handle: {
          title: 'routes.listings.listingView',
          breadcrumb: 'routes.listings.listingView',
        },
      },
      {
        path: LISTING_STATS_ROUTE,
        element: <ListingStatsPage />,
        handle: {
          title: 'routes.listings.listingStats',
          breadcrumb: 'routes.listings.listingStats',
        },
      },
      {
        path: LISTING_LEADS_ROUTE,
        element: <ListingLeadsPage />,
        handle: {
          title: 'routes.listings.listingLeads',
          breadcrumb: 'routes.listings.listingLeads',
        },
      },
      {
        path: JOB_APPLICANTS_ROUTE,
        element: <JobApplicantsPage />,
        handle: {
          title: 'routes.listings.jobApplicants',
          breadcrumb: 'routes.listings.jobApplicants',
        },
      },
      {
        path: `${APPLICANT_CV_ROUTE}/:id`,
        element: <ApplicantCVFullView />,
        handle: {
          title: 'routes.listings.applicantCv',
          breadcrumb: 'routes.listings.applicantCv',
        },
      },
      {
        path: '/listings/my-listings/draft-listings',
        element: <ListingDraft />,
        handle: {
          title: 'routes.listings.drafts',
          breadcrumb: 'routes.listings.drafts',
        },
      },
      {
        path: '/listings/demand/favorite-listings',
        element: <FavoriteListingsPage />,
        handle: {
          title: 'routes.listings.favorites',
          breadcrumb: 'routes.listings.favorites',
        },
      },
      {
        path: '/listings/demand/following-listings',
        element: <FollowingListingsPage />,
        handle: {
          title: 'routes.listings.following',
          breadcrumb: 'routes.listings.following',
        },
      },
      {
        path: '/listings/demand/job-applications',
        element: <JobApplicationsPage />,
        handle: {
          title: 'routes.listings.jobApplications',
          breadcrumb: 'routes.listings.jobApplications',
        },
      },
      {
        path: '/listings/demand/recently-viewed',
        element: <RecentlyViewedPage />,
        handle: {
          title: 'routes.listings.recentlyViewed',
          breadcrumb: 'routes.listings.recentlyViewed',
        },
      },
      {
        path: '/listings/searches/recent-search',
        element: <RecentSearchPage />,
        handle: {
          title: 'routes.recentSearch',
          breadcrumb: 'routes.recentSearch',
        },
      },
      {
        path: '/listings/searches/saved-search',
        element: <SavedSearchPage />,
        handle: {
          title: 'routes.savedSearch',
          breadcrumb: 'routes.savedSearch',
        },
      },
    ],
    handle: {
      breadcrumb: 'routes.listings',
      breadcrumbPath: MY_LISTINGS_ROUTE,
    },
  },
];

export default listingRoutes;
